import servise from '@/router/axios'

export const getChannelDetailReportList = (params) => {
  return servise({
    url: '/report/channel/detail/list',
    method: 'get',
    params
  })
}

export const getChanneltList = (params) => {
  return servise({
    url: '/report/channel/list',
    method: 'get',
    params
  })
}
// 获取CPD报表明细
export const getCpdDetailList = (params) => {
  return servise({
    url: '/report/cpd/detail/list',
    method: 'get',
    params
  })
}

// 检查DAU
export const dauInspect = (params) => {
  return servise({
    url: '/report/dau/inspect',
    method: 'get',
    params
  })
}
